import { defineComponent as _defineComponent } from 'vue'
import { DynamicList } from '@/interfaces/model/general/dynamicList';
import BaseBottomSheet from '@/views/base/BaseBottomSheet.vue';
import BulkResumeDynamicListDialog from '@/views/dashboard/bottomSheet/BulkResumeDynamicListDialog.vue';
import BulkSuspendDynamicListDialog from '@/views/dashboard/bottomSheet/BulkSuspendDynamicListDialog.vue';
import DeleteDynamicListDialog from '@/views/dashboard/bottomSheet/DeleteDynamicListDialog.vue';
import { usePermissionComposable } from '@/composables/usePermission';
import { ref } from 'vue';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'DynamicListBottomSheet',
  props: {
    selectedDynamicLists: null
  },
  emits: ["suspend", "resume", "delete", "favorite", "unfavorite"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'suspend'): void;
  (e: 'resume'): void;
  (e: 'delete'): void;
  (e: 'favorite'): void;
  (e: 'unfavorite'): void;
}), expose: any, slots: any, attrs: any }) {

const m = defineMessages({
  resumeUpdate: '稼働開始',
  selectedCount:
    'このページ内の<b>チェックリスト{count}件</b>のすべてが選択されています。',
  checklistDelete: 'チェックリスト削除',
});





const { hasPermission, PERMISSIONS: P } = usePermissionComposable();

const isSuspendDialogVisible = ref(false);
const isDeleteDialogVisible = ref(false);
const isResumeDialogVisible = ref(false);
const isFavoriteAddDialogVisible = ref(false);

const onConfirmFavoriteAdd = () => {
  emits('favorite');
  isFavoriteAddDialogVisible.value = false;
};

return { __sfc: true,m, emits, hasPermission, P, isSuspendDialogVisible, isDeleteDialogVisible, isResumeDialogVisible, isFavoriteAddDialogVisible, onConfirmFavoriteAdd, BaseBottomSheet, BulkResumeDynamicListDialog, BulkSuspendDynamicListDialog, DeleteDynamicListDialog, sharedMessages }
}

})